import type { ReactNode } from 'react';
import { Component } from 'react';

import type { Logger } from '@shared/types/frontend/logger';

import { withLogging } from '@shared/utils-frontend/contexts/LoggingContext';

type Props = {
  children: ReactNode;
  logger: Logger;
  componentName: string;
};

type State = {
  hasError: boolean;
};

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { hasError: false };
  }

  componentDidCatch(
    error: Error,
    { componentStack }: { componentStack: string },
  ) {
    this.setState({ hasError: true });

    const { componentName, logger } = this.props;
    if (logger) {
      logger.error(
        'Caught non-critical error in ErrorBoundary',
        { componentName, stack: componentStack },
        error,
      );
    }
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    return hasError ? null : children;
  }
}

export default withLogging(ErrorBoundary);
